import styled from 'styled-components';
import Button from '@deprecated-ui/common/Button';
import BaseInput from '@deprecated-ui/common/Input';
import BaseSelect from '@deprecated-ui/widget/Select';
import color from '@deprecated-ui/_style/color';

const MetricContainer = styled.div`
  border-bottom: solid 1px ${color.gainsboro};
  margin-bottom: 15px;
`;

const Select = styled(BaseSelect)`
  width: 50%;
  .ant-select-selector {
    border-bottom: none !important;
  }
`;

const Input = styled(BaseInput)`
  width: 50% !important;
  border-bottom: none;
  border-left: none;
  input {
    border-radius: 3px;
  }
`;

export { MetricContainer, Select, Input, Button };
